import React, { useState } from 'react';
import CoachIdentityRow from './CoachIdentityRow';

// Compact, accessible Identity Review grid. ONE ROW PER PROVISIONAL COACH IDENTITY
// (com_code, typed_name_norm) — never one per evaluation. Single-row expansion (accordion).
// Semantic <table> with column headers; expansion is a keyboard-operable <button> per row.
export default function CoachIdentityList({ rows, candidatesByIdentity, onRowUpdate, onEvaluationSaved, integrationPending = true }) {
  const [expandedKey, setExpandedKey] = useState(null);

  const toggle = (key) => setExpandedKey((cur) => (cur === key ? null : key));
  // Closes ONLY this identity, and only if it is the open one: an identity whose last evaluation was
  // just saved. Never opens anything, unlike toggle.
  const collapse = (key) => setExpandedKey((cur) => (cur === key ? null : cur));

  const rowEls = rows.map((row) => {
    const key = row.reporting_coach_key;
    return (
      <CoachIdentityRow
        key={key}
        row={row}
        candidates={candidatesByIdentity.get(key) || []}
        onRowUpdate={onRowUpdate}
        integrationPending={integrationPending}
        isExpanded={expandedKey === key}
        onToggle={() => toggle(key)}
        onCollapse={() => collapse(key)}
        onEvaluationSaved={onEvaluationSaved}
      />
    );
  });

  // Column order follows the Season Manager identity hierarchy (Franchise -> item being audited ->
  // audited attributes), matching Season Audit and Class Audit. The three independent facts close the
  // row: Identity rule, then the two progress measures, which are deliberately separate columns so a
  // recorded class can never be read as a resolved coach.
  // Wrapped in a horizontal-scroll container with a table min-width so narrow screens scroll rather
  // than crushing the chips.
  // 🔴 tableLayout 'auto' overrides the global `table { table-layout: fixed }` in index.css. Under the
  // fixed layout every column gets an equal share and the minWidths below are ignored, so a one-line
  // value such as a full date range spilled across the next column. Auto layout lets a nowrap cell
  // widen its own column, which makes an overlap impossible rather than merely unlikely.
  return (
    <div className="table-responsive">
      <table className="table table-sm align-middle" style={{ minWidth: 1430, tableLayout: 'auto' }}>
        <thead>
          <tr>
            <th scope="col" aria-label="Expand" style={{ width: 40 }}></th>
            <th scope="col" className="text-start" style={{ minWidth: 130 }}>Franchise</th>
            <th scope="col" className="text-start" style={{ minWidth: 200 }}>Form coach name</th>
            <th scope="col" className="text-start" style={{ minWidth: 90 }}>Evaluations</th>
            <th scope="col" className="text-start" style={{ minWidth: 200 }}>Date range</th>
            <th scope="col" className="text-start" style={{ minWidth: 110 }}>Candidates</th>
            <th scope="col" className="text-start" style={{ minWidth: 180 }}>Accepted coach</th>
            <th scope="col" className="text-start" style={{ minWidth: 170, whiteSpace: 'nowrap' }}>Identity rule</th>
            <th scope="col" className="text-start" style={{ minWidth: 170, whiteSpace: 'nowrap' }}>Evaluation review</th>
            <th scope="col" className="text-start" style={{ minWidth: 140, whiteSpace: 'nowrap' }}>Class audit</th>
            <th scope="col" className="text-start" style={{ minWidth: 190, whiteSpace: 'nowrap' }}>Coach attribution</th>
          </tr>
        </thead>
        <tbody>
          {rowEls}
        </tbody>
      </table>
    </div>
  );
}
